import { createFeatureSelector, createSelector } from '@ngrx/store';
import { commonIdPurchasesFeatureKey, State } from '../../reducers/common-id/common-id-purchases.reducer';

const selectCommonIdPurchasesState = createFeatureSelector<State>(commonIdPurchasesFeatureKey);

export const getCommonIdPurchases = createSelector(selectCommonIdPurchasesState, state => state.purchases);
